<template>
    <a-modal :visible="true" width="40vw" :footer="null" :closable="false" centered wrap-class-name="spm-wrap" @cancel="$emit('close')">
        <div class="spm-modal">
            <div class="spm-head">
                <div>
                    <h3>Vendedor do pedido</h3>
                </div>
                <button class="spm-x" @click="$emit('close')">
                    <span class="material-icons-outlined">close</span>
                </button>
            </div>

            <div class="spm-body">
                <div class="spm-label">Vendedor</div>
                <a-select
                    v-model="sellerId"
                    show-search
                    :filter-option="filterOption"
                    :options="sellers"
                    :loading="loading"
                    :not-found-content="loading ? 'Carregando...' : 'Nenhum vendedor vinculado'"
                    placeholder="Selecione o vendedor"
                    style="width: 100%"
                />
                <div v-if="cnpj" class="spm-hint">
                    <a @click="showAdd = true">Cadastrar novo vendedor</a>
                </div>
            </div>

            <div class="spm-foot">
                <a-button @click="$emit('close')">Cancelar</a-button>
                <a-button type="primary" :disabled="!sellerId" @click="confirm">Continuar</a-button>
            </div>
        </div>

        <AddProviderV2Modal v-if="showAdd" :initial-cnpj="cnpj" @saved="loadSellers(true)" @close="showAdd = false" />
    </a-modal>
</template>

<script>
import ProviderService from "@/services/v3/provider.service";
import AddProviderV2Modal from "@/pages/sellers-v2/modals/add-provider-v2.modal.vue";
import visitFormat from "@/pages/visits/visit-format.mixin";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";

export default {
    name: "SellerOrderSellerPickModal",
    components: { AddProviderV2Modal },
    mixins: [visitFormat, loaderMixin],
    props: {
        provider: { type: Object, required: true },
    },
    data() {
        return {
            sellers: [],
            sellerId: undefined,
            cnpj: "",
            loading: false,
            showAdd: false,
        };
    },
    created() {
        this.loadSellers();
    },
    methods: {
        loadSellers(selectNew = false) {
            const known = new Set(this.sellers.map((seller) => seller.value));
            this.loading = true;
            new ProviderService()
                .loadPurchaseProviders({ "filter[search]": this.provider.name, per_page: 100, compact: 1 })
                .then(({ data }) => {
                    const provider = (data.data || []).find((item) => item.id === this.provider.id);
                    this.cnpj = provider ? String(provider.cnpj || "") : "";
                    this.sellers = provider ? (provider.sellers || []).map((seller) => ({ value: seller.id, label: seller.name })) : [];
                    const added = this.sellers.filter((seller) => !known.has(seller.value));
                    if (selectNew && added.length === 1) this.sellerId = added[0].value;
                })
                .catch((error) => this.notifyError(error, "Não foi possível carregar os vendedores."))
                .finally(() => {
                    this.loading = false;
                });
        },
        filterOption(input, option) {
            const text = option.componentOptions.children[0].text || "";
            return text.toLowerCase().includes(input.toLowerCase());
        },
        confirm() {
            this.$emit("select", this.sellers.find((seller) => seller.value === this.sellerId));
        },
    },
};
</script>

<style lang="scss" scoped>
.spm-modal {
    background: #fff;
    display: flex;
    flex-direction: column;
}
.spm-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 18px 20px 14px;

    h3 {
        font-size: 16px;
        font-weight: 600;
        color: #262626;
        margin: 0;
    }
}
.spm-x {
    width: 28px;
    height: 28px;
    border: none;
    background: none;
    border-radius: 6px;
    color: #8c8c8c;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background: #f0f0f0;
        color: #262626;
    }
}
.spm-body {
    padding: 12px 20px 16px;
    border-top: 1px solid #f0f0f0;
}
.spm-label {
    font-size: 13px;
    color: #262626;
    margin-bottom: 6px;
}
.spm-hint {
    font-size: 12px;
    color: #8c8c8c;
    margin-top: 6px;
}
.spm-foot {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 14px 20px;
    border-top: 1px solid #f0f0f0;
}
</style>

<style lang="scss">
.spm-wrap {
    .ant-modal {
        min-width: 480px;
    }

    .ant-modal-content {
        padding: 0;
        border-radius: 10px;
        overflow: hidden;
    }

    .ant-modal-body {
        padding: 0;
    }
}
</style>
